import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'
import Home from '../views/Home.vue'
import Login from '../components/Login.vue'

Vue.use(Router)
 
let router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/utabs',
      name: 'UserTabs',
      component: () => import(/* webpackChunkName: "tabs" */ '../views/UserTabs.vue'),
      children: [
        {
          path: "user",
          component:  () => import(/* webpackChunkName: "tabs" */ '../views/utabs/Users.vue')
        },
        {
          path: "payment",
          component:  () => import(/* webpackChunkName: "tabs" */ '../views/utabs/Payments.vue')
        },
      ],
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'StgsTabs',
      component: () => import(/* webpackChunkName: "tabs" */ '../views/StgsTabs.vue'),
      children: [
        {
          path: "accounts",
          component:  () => import(/* webpackChunkName: "tabs" */ '../views/settings/Accounts.vue')
        },
        {
          path: "misc",
          component:  () => import(/* webpackChunkName: "tabs" */ '../views/settings/Misc.vue')
        }
      ],
      meta: { 
        requiresAuth: true
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login') 
  } else {
    next() 
  }
});

const DEFAULT_TITLE = 'Admin Panel (EF)';
router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

export default router